import { render, staticRenderFns } from "./display-amount.vue?vue&type=template&id=74ff4151&scoped=true&"
import script from "./display-amount.vue?vue&type=script&lang=js&"
export * from "./display-amount.vue?vue&type=script&lang=js&"
import style0 from "./display-amount.vue?vue&type=style&index=0&id=74ff4151&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff4151",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
